import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Stream from "../components/Image/Stream.svg"
import Artwork from "../components/Image/Artwork.svg"
import Statistic from "../components/Image/Statistic.svg"

function MainDesktop() {
    const history = useHistory()
    return ( 
        <MainDesktopStyle>
            <div className="row-main">
                <div className="col-main">
                    <div className="item" onClick={()=>{
                        history.push(`/artist/stream`);
                    }}>
                        <img src={Stream} alt="Livestream" />
                    </div>
                </div>
                <div className="col-main">
                    <div className="item" onClick={()=>{
                        history.push(`/artist/artwork`);
                    }}>
                        <img src={Artwork} alt="Artwork" />
                    </div>
                </div>
                <div className="col-main w-100" hidden>
                    <div className="item" onClick={()=>{
                        history.push(`/artist/statistic`);
                    }}>
                        <img src={Statistic} alt="Thống kê" />
                    </div>
                </div>

            </div>

        </MainDesktopStyle>
    );
}
const MainDesktopStyle = styled.div`
    width: 100%;
    padding: 0 24px;

    .row-main{
        max-width: calc(1024px * 80 / 100);
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-left: -12px;
        margin-right: -12px;

        .col-main{
            padding: 0 12px;
            width: 50%;
            margin-bottom: 24px;

            &.w-100{
                width: 100%;
            }

            .item{
                width: 100%;
                border-radius: 10px;
                cursor: pointer;

                img{
                    width: 100%;

                }
            }

        }

    }
    


`
export default MainDesktop;


// WEBPACK FOOTER //
// ./src/artist-ui/Main/MainDesktop.js